import { useSyncExternalStore } from 'react'

/**
 * Whether the viewer asked for reduced motion (spec §10: the play head steps by beat). Subscribed, so
 * changing the setting while the editor is open takes effect at once.
 */

const query = '(prefers-reduced-motion: reduce)'

const mediaQuery = () => (typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(query) : null)

const subscribe = (listener: () => void) => {
  const media = mediaQuery()
  media?.addEventListener('change', listener)
  return () => media?.removeEventListener('change', listener)
}

const getSnapshot = () => mediaQuery()?.matches ?? false

export const usePrefersReducedMotion = (): boolean => useSyncExternalStore(subscribe, getSnapshot, () => false)
